import * as React from 'react';
import { Trans } from '@lingui/macro';

export const tAddMcCivilStatusLabel = <Trans>Etat civil</Trans>;
